module.exports = __webpack_public_path__ + "static/media/mccafee@2x.3b7b865b.png";